import React, { useMemo, useState, useEffect, useContext } from "react";
import _ from "lodash"
import {useTransition, animated} from 'react-spring';
import { NavLink, Switch, Route, useHistory } from "react-router-dom";
import { useGlobalContext } from '../../../GlobalContext'

import { StepProvider } from './StepContext'
import ModalContext from '../../../ModalContext'

import Form from './Form'
import SubmitSucceed from './SubmitSucceed'
import ModalSupportContact from '../../../partials/ModalSupportContact'

const StandForm = (props) => {
  const context = useGlobalContext()[0];
  const { authReducer, showRoomReducer } = context;
  const history = useHistory();
  const { exhibition } = authReducer;
  const modalContext = useContext(ModalContext);

  const transitions = useTransition(history.location, location => location.pathname, {
    from: { opacity: 0, transform : 'translate(40%,0)' },
    enter: { opacity: 1, transform : 'translate(0,0)' },
    leave: { opacity: 0, transform : 'translate(-40%,0)' },
  })

  // STATE / CONTEXT
  const [step1, setStep1] = useState(false);
  const wasNegociated = !!showRoomReducer?.formData?.negotiatedPrice;

  // showroom id 63ecb454bc39403d4c715fc8

  //NOTE : set step 1 if there are all needed data
  useEffect(()=>{
    if(_.isEmpty(showRoomReducer.formData)) return;

    if (showRoomReducer.formData?.dimension 
      || !exhibition?.showroomOption?.displayShowroomSize
    ) {
       setStep1(true);
    }
  },[
    exhibition?.showroomOption?.displayShowroomSize,
    showRoomReducer.formData,
  ]);

  //NOTE : set step 1 if there are all needed data
  useEffect(()=>{
    if(_.isEmpty(showRoomReducer.formData) || !showRoomReducer.formData.option) return;

    let done = true;
    const countChair = typeof showRoomReducer.formData.option.chair === 'number' ? showRoomReducer.formData.option.chair : showRoomReducer.formData.option.countChair;
    const countTable = typeof showRoomReducer.formData.option.table === 'number' ? showRoomReducer.formData.option.table : showRoomReducer.formData.option.countTable;

    const fridgeValue = true;

    if (exhibition.showroomOption.fridge.isAvailable && exhibition.fridgeProvided) {
      const countFridge = typeof showRoomReducer.formData.option.fridge === 'number' ? showRoomReducer.formData.option.fridge : showRoomReducer.formData.option.countFridge;
      if (!countFridge && showRoomReducer.formData.option.fridge) {
        done = false;
      }
    } else if (exhibition.showroomOption.fridge.isAvailable) {
      const fridgeLength = showRoomReducer.formData.option.fridgeLength;
      if (!fridgeLength && showRoomReducer.formData.option.fridge) {
        done = false;
      }
    }

    if (
      (exhibition.showroomOption.chairs.isAvailable && !countChair && showRoomReducer.formData.option.chair)
      || (!countTable && showRoomReducer.formData.option.table)
      || (exhibition.showroomOption.power.isAvailable && !showRoomReducer.formData.option.powerQuantity && showRoomReducer.formData.option.power)
    ) {
      done = false;
    }
    
    if (exhibition?.showroomOption?.displayShowroomSize &&
      (!showRoomReducer.formData.dimension 
      || showRoomReducer.formData.dimension === 0)
    ) done = false;

    setStep1(done);
  },[
    showRoomReducer.formData,
    exhibition?.showroomOption?.displayShowroomSize,
    exhibition.showroomOption.chairs.isAvailable,
    exhibition.showroomOption.power.isAvailable,
    exhibition.showroomOption.fridge.isAvailable,
  ]);

  return useMemo(() => {

    let StepProviderValue = {
      step1,
      setStep1,
    }

    return (
      <>
      <div className="stand-form" style={{overflowX: "hidden"}}>
        <StepProvider value={StepProviderValue}>
          <div className="content">
            <div className={"nav-provider-from"}>
              <div className="title-page">
                <h2>Mon stand</h2>
              </div>
            </div>
          </div>
          {
            transitions.map(({ item, props, key }) => (
              <animated.div key={key} className="container-step" style={{...props}}>
                <div className="content">
                  <Switch location={item}>
                     <Route exact path="/stand/form" render={
                      () => <Form/>
                    }/>
                    <Route exact path="/stand/submit-succeed" component={SubmitSucceed}/>
                  </Switch>
                </div>
              </animated.div>
            ))
          }
          <ModalSupportContact />
        </StepProvider>
      </div>
      </>
    )
    // eslint-disable-next-line
  },[
    history.location.pathname,
    step1,
    wasNegociated,
    modalContext.isModalOpen,
  ]);
}

export default StandForm;
